import { User } from "reauthorize";

export interface CurrentUser extends User {
    id?: string;
    name: string;
    termsAcceptanceRequired: boolean;
    email?: string;
    canSwitchBetweenPortals: boolean;
}

export const ANONYMOUS_USER = "ANONYMOUS_USER";
